<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="pageConfig.isVisibleHelpPage ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate('')"
  [bodyClass]="input_isModalMode ? 'tw-p-3' : 'tw-pt-3 tw-pl-3  tw-pr-5'"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- title -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.title"
          ></td-value>
        </td>

        <!-- urlType -->
        <td>
          <span
            [urlTypeIcon]="item?.urlType"
            [matTooltip]="item?.urlType | enumToText : UrlTypeEnumValues"
            copyToClipboard
          ></span>
        </td>

        <!-- shortUrl -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            openLink
            [value]="item?.shortUrl"
          ></td-value>
        </td>

        <!-- mainUrl -->
        <td>
          <div class="tw-px-3">
            <td-value
              class="font-vazir-ui"
              copyToClipboard
              openLink
              [value]="item?.mainUrl"
            ></td-value>
          </div>
        </td>

        <!-- isActive -->
        <td *ngIf="!this.input_isModalMode">
          <td-value type="boolean" [value]="item?.isActive"></td-value>
        </td>

        <!-- created -->
        <td *ngIf="!this.input_isModalMode">
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        @if(input_isModalMode){
        <!-- select -->
        <td class="sticky-td">
          <a
            (click)="onSelect(item?.shortUrl)"
            class="text-info tw-font-bold tw-cursor-pointer tw-mx-4"
            [matTooltip]="'common.select' | translate"
          >
            <i class="mdi mdi-text-box-plus-outline text-blue mdi-24px"></i>
          </a>
        </td>
        } @else{
        <td class="sticky-td">
          <div class="tw-flex-center tw-h-full tw-w-full">
            <!-- set isActive to false -->
            <a
              *ngIf="
                item.isActive && permissionService.userState()?.isSuperAdmin
              "
              (click)="onIsActive(item.id, false)"
              class="btn btn-sm"
              [matTooltip]="'common.do_pause' | translate"
            >
              <i class="mdi mdi-check-bold mdi-20px text-danger"></i>
            </a>

            <!--set isActive to true-->
            <a
              *ngIf="
                !item.isActive && permissionService.userState()?.isSuperAdmin
              "
              (click)="onIsActive(item.id, true)"
              class="btn btn-sm"
              [matTooltip]="'common.do_play' | translate"
            >
              <i class="mdi mdi-check-bold mdi-20px text-success"></i>
            </a>

            <!--stats-->
            <a
              (click)="shortLinkReportApi(item?.id)"
              class="btn btn-sm"
              [matTooltip]="'common.stats' | translate"
            >
              <i class="mdi mdi-download mdi-20px text-warning"></i>
            </a>
          </div>
        </td>
        }
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-short-links-form
    page-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-short-links-form>
</ng-container>

<!--------------------------------------- Audit ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
